export default __webpack_public_path__ + "static/media/military.b260480c.png";